import { render } from "./BsCarousel.vue?vue&type=template&id=720e45d4"
const script = {}
script.render = render

export default script